module.exports = __webpack_public_path__ + "static/media/flyer (1).1aaa683e.jpg";